const state = () => ({
  context: new Map(),
  queue: [],
  preContextData: context(),
});

const context = () => ({
  willSetNids: false,
  nids: [],
  ready: false,
});

const getters = {
  isReady: (state) => (_this) => {
    const ctx = state.context.get(_this.$router.currentRoute.path);
    if (ctx) {
      return ctx.ready && state.queue[0] === _this.$router.currentRoute.path;
    }
    return false;
  },
  getData: (state) => (_this) => {
    const ctx = state.context.get(_this.$router.currentRoute.path);
    if (ctx) {
      return ctx.nids;
    }
    return false;
  },
  getWillSetData: (state) => (_this) => {
    const ctx = state.context.get(_this.$router.currentRoute.path);
    if (ctx) {
      return ctx.willSetNids;
    }
    return false;
  },
  front: (state) => state.queue[0],
};

const mutations = {
  init(state) {
    init(this, state);
  },
  willSetData(state) {
    const key = init(this, state);
    if (key) {
      const realState = state.context.get(key);
      realState.willSetNids = true;
    }
  },
  appendData(state, data) {
    const key = init(this, state);
    if (key) {
      const realState = state.context.get(key);
      realState[data.label].push(data.data);
    }
  },
  setReady(state) {
    const key = init(this, state);
    if (key) {
      const realState = state.context.get(key);
      realState.ready = true;
    }
  },
  dequeue(state) {
    const front = state.queue.shift();

    if (front) {
      state.context.delete(front);
    }
  },
};

function init(_this, state) {
  let key = _this.$router.currentRoute.path;
  const beforeKey = "$before";

  if (_this.app.$isBefore) {
    key = beforeKey;
  } else {
    const beforeContext = state.context.get(beforeKey);
    if (beforeContext) {
      state.context.delete(beforeKey);
      state.context.set(key, beforeContext);
    }
    if (state.queue.length > 0 && state.queue[0] === beforeKey) {
      state.queue[0] = key;
    }
  }

  if (key && !state.context.get(key)) {
    state.context.set(key, context());
    state.queue.push(key);
  }
  return key;
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
